import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn_reset = _resolveComponent("v-btn-reset")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_text_field_filled, {
      modelValue: _ctx.search_,
      "onUpdate:modelValue": [
        _cache[10] || (_cache[10] = ($event: any) => ((_ctx.search_) = $event)),
        _ctx.updatedFilter
      ],
      label: "Rechercher",
      density: "compact",
      outlined: "",
      "single-line": "",
      "hide-details": "",
      color: "primary",
      clearable: "",
      "onClick:clear": _cache[11] || (_cache[11] = ($event: any) => (_ctx.search_ = '')),
      onKeypress: _withKeys(_ctx.keypressEnter, ["enter"])
    }, {
      "append-inner": _withCtx(() => [
        _createVNode(_component_v_menu, {
          modelValue: _ctx.menu,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.menu) = $event)),
          "close-on-content-click": false,
          "offset-y": "",
          left: "",
          bottom: "",
          elevation: "1"
        }, {
          activator: _withCtx(({ props }) => [
            _createVNode(_component_v_btn_icon, _mergeProps({
              elevation: "0",
              icon: "$tune",
              size: "small",
              style: {"margin-top":"-2px"}
            }, props, { "data-cy": "planFilterBar-dialog" }), null, 16)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              class: _normalizeClass({ 'pa-3 pb-0': true, 'mt-3': _ctx.$vuetify.display.mobile }),
              elevation: "1",
              style: _normalizeStyle({ width: !_ctx.$vuetify.display.mobile ? '700px' : undefined })
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => _cache[12] || (_cache[12] = [
                        _createElementVNode("h3", null, "Filtres", -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, {
                  "no-gutters": "",
                  class: "py-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: _ctx.$vuetify.display.mobile ? '12' : '4',
                      class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'pa-1' : 'px-1'),
                      "data-cy": "scopeFilterBar-taxSystem"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select_filled, {
                          modelValue: _ctx.transactionType_,
                          "onUpdate:modelValue": [
                            _cache[0] || (_cache[0] = ($event: any) => ((_ctx.transactionType_) = $event)),
                            _ctx.updatedFilter
                          ],
                          label: "Filtrer par transaction",
                          items: _ctx.transactionTypes,
                          "hide-details": true
                        }, null, 8, ["modelValue", "items", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }, 8, ["cols", "class"]),
                    _createVNode(_component_v_col, {
                      cols: _ctx.$vuetify.display.mobile ? '12' : '4',
                      class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'pa-1' : 'px-1'),
                      "data-cy": "scopeFilterBar-taxSystem"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select_filled, {
                          modelValue: _ctx.vatType_,
                          "onUpdate:modelValue": [
                            _cache[1] || (_cache[1] = ($event: any) => ((_ctx.vatType_) = $event)),
                            _ctx.updatedFilter
                          ],
                          label: "Filtrer par type de TVA",
                          items: _ctx.vatTypes,
                          "hide-details": true
                        }, null, 8, ["modelValue", "items", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }, 8, ["cols", "class"]),
                    _createVNode(_component_v_col, {
                      cols: _ctx.$vuetify.display.mobile ? '12' : '4',
                      class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'pa-1' : 'px-1'),
                      "data-cy": "scopeFilterBar-taxSystem"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select_filled, {
                          modelValue: _ctx.vatOperation_,
                          "onUpdate:modelValue": [
                            _cache[2] || (_cache[2] = ($event: any) => ((_ctx.vatOperation_) = $event)),
                            _ctx.updatedFilter
                          ],
                          label: "Filtrer par opération de TVA",
                          items: _ctx.vatOperationTypes,
                          "hide-details": true
                        }, null, 8, ["modelValue", "items", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }, 8, ["cols", "class"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, {
                  "no-gutters": "",
                  class: "py-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: _ctx.$vuetify.display.mobile ? '12' : '4',
                      class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'pa-1' : 'px-1'),
                      "data-cy": "scopeFilterBar-taxSystem"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select_filled, {
                          modelValue: _ctx.thirdParty_,
                          "onUpdate:modelValue": [
                            _cache[3] || (_cache[3] = ($event: any) => ((_ctx.thirdParty_) = $event)),
                            _ctx.updatedFilter
                          ],
                          label: "Filtrer par tiers",
                          items: _ctx.thirdParties,
                          "hide-details": true
                        }, null, 8, ["modelValue", "items", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }, 8, ["cols", "class"]),
                    _createVNode(_component_v_col, {
                      cols: _ctx.$vuetify.display.mobile ? '4' : '3',
                      class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'pa-1' : 'px-1'),
                      "data-cy": "planFilterBar-user"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_checkbox, {
                          modelValue: _ctx.lettering_,
                          "onUpdate:modelValue": [
                            _cache[4] || (_cache[4] = ($event: any) => ((_ctx.lettering_) = $event)),
                            _ctx.updatedFilter
                          ],
                          label: "À lettrer",
                          density: "compact"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }, 8, ["cols", "class"]),
                    _createVNode(_component_v_col, {
                      cols: _ctx.$vuetify.display.mobile ? '4' : '3',
                      class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'pa-1' : 'px-1'),
                      "data-cy": "planFilterBar-user"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_checkbox, {
                          modelValue: _ctx.publish_,
                          "onUpdate:modelValue": [
                            _cache[5] || (_cache[5] = ($event: any) => ((_ctx.publish_) = $event)),
                            _ctx.updatedFilter
                          ],
                          label: "Publié",
                          density: "compact"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }, 8, ["cols", "class"]),
                    _createVNode(_component_v_col, {
                      cols: _ctx.$vuetify.display.mobile ? '4' : '2',
                      class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'pa-1' : 'px-1'),
                      "data-cy": "planFilterBar-user"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_checkbox, {
                          modelValue: _ctx.default_,
                          "onUpdate:modelValue": [
                            _cache[6] || (_cache[6] = ($event: any) => ((_ctx.default_) = $event)),
                            _ctx.updatedFilter
                          ],
                          label: "Par défaut",
                          density: "compact"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }, 8, ["cols", "class"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_divider),
                _createVNode(_component_v_card_actions, { class: "d-flex justify-space-between" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn_reset, {
                      onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.clearMenu()), ["stop"])),
                      "data-cy": "scopeFilterBar-resetFilter",
                      size: "small"
                    }),
                    _createVNode(_component_v_btn, {
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.menu = false)),
                      "data-cy": "scopeFilterBar-validate",
                      size: "small",
                      variant: "tonal"
                    }, {
                      default: _withCtx(() => _cache[13] || (_cache[13] = [
                        _createTextVNode(" Valider ")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["class", "style"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue", "onKeypress", "onUpdate:modelValue"])
  ]))
}